module.exports = __webpack_public_path__ + "img/64.b3db085d.jpg";